export default "__VITE_ASSET__NBORydq$__"